import React, { ReactElement, useEffect, useState } from 'react';
import { Alert, Modal } from 'react-bootstrap';
import {
  useGetExperienceLevelsMutation,
  useGetUserExpMutation,
} from '../../../services/api/apiProvider';
import { AppState } from '../../../store/store';
import { ImageCustom } from '../../../common/components/ImageCustom';
import { useSelector } from 'react-redux';
import './LevelProfileModal.scss';
import { getLevelColor } from '../../../common/utils/utils';

export interface LevelProps {
  isShowLevelModal?: boolean;
  handleCloseLevelModal: (child: boolean) => void;
}

const LevelProfileModal = (props: LevelProps): ReactElement => {
  const [getUserExp, expResult] = useGetUserExpMutation();
  const [getExperienceLevels, levelsResult] = useGetExperienceLevelsMutation();
  const { userData } = useSelector((state: AppState) => state.profilePageState);
  const [currentLevel, setCurrentLevel] = useState<{
    exp: null | number;
    nextExp: null | number;
  }>({ exp: null, nextExp: null }); //data level exp start from 0

  useEffect(() => {
    fetchLevelData();
  }, []);

  const fetchLevelData = async () => {
    const [expData, levelsData] = await Promise.all([
      getUserExp().unwrap(),
      getExperienceLevels().unwrap(),
    ]);
    if (expData && levelsData) {
      const currentLevel = levelsData.find(
        (level) => level.level === userData?.user.level,
      );
      if (!currentLevel) return;
      setCurrentLevel({
        exp: expData.point - currentLevel?.exp,
        nextExp: currentLevel?.nextLevelExp - currentLevel?.exp,
      });
    }
  };

  return (
    <Modal
      show={props.isShowLevelModal}
      backdrop="static"
      keyboard={false}
      centered
      onHide={() => {
        props.handleCloseLevelModal(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>レベル</Modal.Title>
      </Modal.Header>

      <Modal.Body className="level-modal-body">
        <div
          className="level-modal-avatar"
          style={{
            border: `10px solid ${getLevelColor(userData?.user.level)}`,
          }}
        >
          <ImageCustom src={userData?.user.picture.uri} />
        </div>
        <div
          className="level-modal-level"
          style={{ backgroundColor: getLevelColor(userData?.user.level) }}
        >
          {`Lv.${userData?.user.level}`}
        </div>
        <div className="level-modal-rate">
          <div
            className="level-modal-current-rate"
            style={{
              backgroundColor: getLevelColor(userData?.user.level),
              width: `${
                (Number(currentLevel.exp) / Number(currentLevel.nextExp)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div className="level-modal-experience">
          {currentLevel.exp}/{currentLevel.nextExp}EXP
        </div>
        <div className="level-modal-description">
          ・ギフトをたくさん送ってレベルを上げよう
          <br />
          ・配信を盛り上げて経験値をもらおう
        </div>

        {(expResult.error || levelsResult.error) && (
          <Alert variant="danger" className="level-error-message">
            {(expResult.error as any)?.data?.message ||
              (levelsResult.error as any)?.data?.message}
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LevelProfileModal;
